module.exports = "<app-job-description *ngFor=\"let job of itemsFormArray.controls; let i=index\" [index]=\"i\" [job]=\"job\" (removed)=\"itemsFormArray.removeAt($event)\">\n</app-job-description>\n<button type=\"button\" class=\"btn btn-outline-info btn-sm float-right\" (click)=\"addItem()\">I have more job experiences</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/jobs/jobs.component.html
// module id = ./src/app/main/content/jobs/jobs.component.html
// module chunks = main